import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullConstruction extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={401} width={774}>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(-599 -111)">
            <g transform="translate(-18 44)">
              <g transform="translate(617 67)">
                <path d="M293,162 L228,232" stroke="#B0E3F4" strokeWidth="2" />
                <path d="M291,162 L356,232" stroke="#B0E3F4" strokeWidth="2" />
                <path d="M292,100 L292,166" stroke="#B0E3F4" strokeWidth="2" />
                <path
                  d="M295.993987,163.365773 C295.993987,165.611536 294.173019,167.43271 291.925694,167.43271 C289.679183,167.43271 287.857402,165.611536 287.857402,163.365773 C287.857402,161.119197 289.679183,159.298836 291.925694,159.298836 C294.173019,159.298836 295.993987,161.119197 295.993987,163.365773"
                  fill="#FEAD64"
                />
                <polygon
                  fill="#23C991"
                  points="264.329489 232.333544 274.335861 232.333544 274.335861 200.984779 264.329489 200.984779"
                />
                <path
                  d="M264.329652,204.063776 L270.583431,204.063776"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M266.205623,224.496962 L272.459402,224.496962"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M266.205623,227.505845 L272.459402,227.505845"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <polygon
                  fill="#FE9840"
                  points="286.810874 225.416497 328.151237 225.416497 328.151237 218.488876 286.810874 218.488876"
                />
                <path
                  d="M309.43286,220.387078 L309.43286,223.516993"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M324.590423,220.387078 L324.590423,223.516993"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M305.858783,220.387078 L305.858783,223.516993"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M302.284707,220.387078 L302.284707,223.516993"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#00A7DB"
                  points="285.068424 232.568857 274.751234 231.310546 280.150672 187.071218 290.467049 188.329528"
                />
                <path
                  d="M283.886829,192.204506 L289.904648,192.938181"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="283.693748 218.807155 279.39519 218.28252 281.524535 200.832919 285.823093 201.357554"
                />
                <polygon
                  fill="#23C991"
                  points="289.838498 218.449834 323.427136 218.449834 323.427136 204.730428 289.838498 204.730428"
                />
                <polygon
                  fill="#86E0C2"
                  points="301.54623 215.150734 318.289696 215.150734 318.289696 208.626554 301.54623 208.626554"
                />
                <polygon
                  fill="#00A7DB"
                  points="292.857171 232.370146 331.613354 232.370146 331.613354 225.443339 292.857171 225.443339"
                />
                <path
                  d="M325.261041,230.533761 L325.261041,227.280212"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <path
                  d="M328.087365,230.533761 L328.087365,227.280212"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="304.995329 230.533517 321.739608 230.533517 321.739608 227.279968 304.995329 227.279968"
                />
                <polygon
                  fill="#B0E3F4"
                  points="226.358486 237.24803 360.612144 237.24803 360.612144 232.367706 226.358486 232.367706"
                />
                <polygon
                  fill="#75CFEC"
                  points="245.232923 354.283093 250.114874 354.283093 250.114874 295.947761 245.232923 295.947761"
                />
                <polygon
                  fill="#75CFEC"
                  points="420.983167 354.283093 425.865118 354.283093 425.865118 295.947761 420.983167 295.947761"
                />
                <polygon
                  fill="#F58525"
                  points="191.913065 362.271371 228.509799 362.271371 228.509799 358.38826 191.913065 358.38826"
                />
                <polygon
                  fill="#FE9840"
                  points="212.968189 326.082951 207.454838 326.082951 197.443584 358.466345 222.979443 358.466345"
                />
                <polygon
                  fill="#FFF"
                  points="199.468943 351.91516 220.953596 351.91516 218.95281 345.442223 201.469729 345.442223"
                />
                <polygon
                  fill="#FFF"
                  points="205.472115 332.496348 203.470515 338.969286 216.952024 338.969286 214.950424 332.496348"
                />
                <path
                  d="M36.6149424,99.7062505 L130.446045,3.33610852"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M199.427609,81.7172116 L130.87525,3.33594584"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M282.976264,81.7172116 L130.875006,3.33594584"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M207.139953,82.2708844 L190.72846,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M207.139953,98.6768274 L190.72846,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M228.173433,82.2708844 L211.76194,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M228.173433,98.6768274 L211.76194,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M248.66111,82.2708844 L232.249618,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M248.66111,98.6768274 L232.249618,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M269.694672,82.2708844 L253.283179,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M269.694672,98.6768274 L253.283179,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M286.690127,86.571345 L274.316822,98.6769901"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M290.72742,98.6768274 L274.31674,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M186.107205,82.2708844 L169.695712,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M186.107205,98.6768274 L173.006489,85.713872"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#55D5A9"
                  strokeWidth="2"
                  points="299.958945 99.9588886 159.581692 99.9588886 176.719782 82.1457041 282.821669 82.1457041"
                />
                <path
                  d="M90.6000472,82.2708844 L74.1893682,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M90.6000472,98.6768274 L74.1893682,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M106.738883,86.571345 L94.3655776,98.6769901"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M110.776989,98.6768274 L94.3654962,82.270803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M69.5672995,82.2708844 L53.1558068,98.6769087"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M69.5672995,98.6768274 L56.4665834,85.713872"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#55D5A9"
                  strokeWidth="2"
                  points="120.007782 99.9588886 43.0413803 99.9588886 60.1802837 82.1457041 102.870506 82.1457041"
                />
                <path
                  d="M131.173293,302.695704 L147.584786,319.101728"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,302.695704 L131.173212,319.101728"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,281.669965 L147.584786,298.075989"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,281.669965 L131.173212,298.075989"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,260.643412 L147.584786,277.049436"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,260.643412 L131.173212,277.049436"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,239.617672 L147.584786,256.022883"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,239.617672 L131.173212,256.022883"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,218.591119 L147.584786,234.997143"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,218.591119 L131.173212,234.997143"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,197.564566 L147.584786,213.97059"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,197.564566 L131.173212,213.97059"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,176.538827 L147.584786,192.944851"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,176.538827 L131.173212,192.944851"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,155.512274 L147.584786,171.918298"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,155.512274 L131.173212,171.918298"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,134.486534 L147.584786,150.891745"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,134.486534 L131.173212,150.891745"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,113.459981 L147.584786,129.866005"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M147.584704,113.459981 L131.173212,129.866005"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,68.0588099 L147.584786,84.4648343"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M145.442504,70.4378055 L131.173374,84.4646716"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,47.5001174 L142.444091,58.4450586"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M141.586413,53.8769935 L131.173212,63.9052471"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M131.173293,30.3674128 L138.301755,37.3153682"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M138.444552,39.7420282 L131.172886,46.7737625"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M130.945224,113.412317 L130.945224,326.13997"
                  stroke="#55D5A9"
                  strokeWidth="2"
                />
                <path
                  d="M130.945224,4.62101663 L130.945224,97.1552235"
                  stroke="#55D5A9"
                  strokeWidth="2"
                />
                <path
                  d="M130.945224,4.62101663 L149.797693,90.3016211"
                  stroke="#55D5A9"
                  strokeWidth="2"
                />
                <path
                  d="M147.762733,113.412317 L147.762733,326.13997"
                  stroke="#55D5A9"
                  strokeWidth="2"
                />
                <polygon
                  fill="#23C991"
                  points="126.52177 239.929769 152.655668 239.929769 152.655668 234.790787 126.52177 234.790787"
                />
                <polygon
                  fill="#23C991"
                  points="126.629173 327.733314 152.763071 327.733314 152.763071 322.594333 126.629173 322.594333"
                />
                <polygon
                  fill="#23C991"
                  points="126.52177 176.539233 152.655668 176.539233 152.655668 171.400252 126.52177 171.400252"
                />
                <polygon
                  fill="#23C991"
                  points="35.688999 102.869921 307.899276 102.869921 307.899276 97.7309391 35.688999 97.7309391"
                />
                <polygon
                  fill="#23C991"
                  points="125.30535 113.455345 154.483145 113.455345 154.483145 84.2872718 125.30535 84.2872718"
                />
                <polygon
                  fill="#86E0C2"
                  points="131.192983 107.569673 148.595512 107.569673 148.595512 90.1729432 131.192983 90.1729432"
                />
                <path
                  d="M40.8993428,100.134418 C40.8993428,102.499748 38.9815497,104.417716 36.614617,104.417716 C34.248498,104.417716 32.3307048,102.499748 32.3307048,100.134418 C32.3307048,97.769087 34.248498,95.8511195 36.614617,95.8511195 C38.9815497,95.8511195 40.8993428,97.769087 40.8993428,100.134418"
                  fill="#FEAD64"
                />
                <path
                  d="M135.588041,4.62101663 C135.588041,6.98634726 133.670248,8.90431481 131.303316,8.90431481 C128.937196,8.90431481 127.019403,6.98634726 127.019403,4.62101663 C127.019403,2.255686 128.937196,0.337718458 131.303316,0.337718458 C133.670248,0.337718458 135.588041,2.255686 135.588041,4.62101663"
                  fill="#FEAD64"
                />
                <path
                  d="M286.472392,81.8458895 C286.472392,83.5011329 285.130669,84.8440355 283.473247,84.8440355 C281.816638,84.8440355 280.474101,83.5011329 280.474101,81.8458895 C280.474101,80.1898327 281.816638,78.84693 283.473247,78.84693 C285.130669,78.84693 286.472392,80.1898327 286.472392,81.8458895"
                  fill="#FEAD64"
                />
                <path
                  d="M202.838791,82.0293897 C202.838791,83.6854465 201.496254,85.0283491 199.838832,85.0283491 C198.183037,85.0283491 196.8405,83.6854465 196.8405,82.0293897 C196.8405,80.3741462 198.183037,79.0312436 199.838832,79.0312436 C201.496254,79.0312436 202.838791,80.3741462 202.838791,82.0293897"
                  fill="#FEAD64"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="73.0676585 361.815874 106.469969 361.815874 106.469969 328.424694 73.0676585 328.424694"
                />
                <path
                  d="M73.3224964,328.718571 L106.372492,361.757554"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M106.372655,328.718571 L73.3226591,361.757554"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="90.206562 328.406799 123.608872 328.406799 123.608872 295.015619 90.206562 295.015619"
                />
                <path
                  d="M90.460993,295.310065 L123.510989,328.349049"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M123.51107,295.310065 L90.4610743,328.349049"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="106.487869 361.815874 139.89018 361.815874 139.89018 328.424694 106.487869 328.424694"
                />
                <path
                  d="M106.742138,328.718571 L139.792134,361.757554"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M139.792215,328.718571 L106.742219,361.757554"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="139.907266 361.815874 173.309577 361.815874 173.309577 328.424694 139.907266 328.424694"
                />
                <path
                  d="M140.161697,328.718571 L173.211693,361.757554"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M173.211775,328.718571 L140.161779,361.757554"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <g transform="translate(4.497 352.197)">
                  <path
                    d="M44.4678222,0.688288438 L0.530261268,0.688288438"
                    fill="#FFF"
                  />
                  <path
                    d="M44.4678222,0.688288438 L0.530261268,0.688288438"
                    stroke="#B0E3F4"
                    strokeWidth="4"
                  />
                </g>
                <g transform="translate(10.192 318.034)">
                  <path
                    d="M0.530261268,0.688288438 L0.530261268,44.6112093"
                    fill="#FFF"
                  />
                  <path
                    d="M0.530261268,0.688288438 L0.530261268,44.6112093"
                    stroke="#B0E3F4"
                    strokeWidth="2"
                  />
                </g>
                <g transform="translate(42.739 318.034)">
                  <path
                    d="M0.530261268,0.688288438 L0.530261268,44.6112093"
                    fill="#FFF"
                  />
                  <path
                    d="M0.530261268,0.688288438 L0.530261268,44.6112093"
                    stroke="#B0E3F4"
                    strokeWidth="2"
                  />
                </g>
                <polygon
                  fill="#FE9840"
                  points="0.938456585 342.304337 53.0532859 342.304337 53.0532859 322.783039 0.938456585 322.783039"
                />
                <polygon
                  fill="#FFF"
                  points="11.446287 342.311006 2.57008605 342.311006 10.7807143 322.789708 19.6569153 322.789708"
                />
                <polygon
                  fill="#FFF"
                  points="27.7194578 342.311006 18.8432568 342.311006 27.0538851 322.789708 35.930086 322.789708"
                />
                <polygon
                  fill="#FFF"
                  points="43.2179442 342.311006 34.3417432 342.311006 42.5523715 322.789708 51.4285725 322.789708"
                />
                <polygon
                  fill="#23C991"
                  points="254.497239 354.104961 268.354658 354.104961 268.354658 308.555266 254.497239 308.555266"
                />
                <path
                  d="M254.497402,313.029059 L263.158797,313.029059"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M257.095658,342.7177 L265.757053,342.7177"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M257.095658,347.089658 L265.757053,347.089658"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <polygon
                  fill="#FE9840"
                  points="285.676634 354.104961 303.865157 354.104961 303.865157 311.808815 285.676634 311.808815"
                />
                <path
                  d="M289.140623,330.651911 L300.400843,330.651911"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M289.140623,316.010938 L300.400843,316.010938"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M289.140623,335.023869 L300.400843,335.023869"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#FE9840"
                  points="366.90498 354.104961 373.834096 354.104961 373.834096 302.048166 366.90498 302.048166"
                />
                <path
                  d="M368.804465,325.618263 L371.935423,325.618263"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M368.804465,306.530663 L371.935423,306.530663"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M368.804465,330.118898 L371.935423,330.118898"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M368.804465,334.619615 L371.935423,334.619615"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#FE9840"
                  points="162.551628 326.668428 155.306812 327.541192 148.744656 273.110933 155.989471 272.238168"
                />
                <path
                  d="M153.701464,297.516704 L156.973998,297.122211"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M151.295475,277.558535 L154.56801,277.164856"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M154.268828,302.222313 L157.541362,301.828633"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M154.836192,306.928654 L158.108726,306.534161"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#00A7DB"
                  points="271.524671 354.104961 281.917532 354.104961 281.917532 305.301716 271.524671 305.301716"
                />
                <path
                  d="M275.855125,310.38555 L281.917694,310.38555"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="274.556363 339.328152 278.886654 339.328152 278.886654 320.077712 274.556363 320.077712"
                />
                <polygon
                  fill="#00A7DB"
                  points="348.501976 348.734734 334.008277 354.474809 316.327477 309.858068 330.82199 304.117993"
                />
                <path
                  d="M318.22501,314.647863 L328.692727,310.502027"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <path
                  d="M319.723606,318.428894 L330.191323,314.283059"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <path
                  d="M334.533086,345.809223 L342.585051,342.620744"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#23C991"
                  points="325.592362 352.245639 314.624245 354.787475 304.334719 310.413937 315.302836 307.872102"
                />
                <path
                  d="M307.884956,312.30547 L312.947539,311.132565"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M308.872656,316.56461 L313.935239,315.391706"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <polygon
                  fill="#86E0C2"
                  points="322.0811 350.172396 316.864735 351.380276 313.939633 338.764637 319.155184 337.555944"
                />
                <polygon
                  fill="#23C991"
                  points="351.843346 354.104961 363.102753 354.104961 363.102753 311.808815 351.843346 311.808815"
                />
                <polygon
                  fill="#86E0C2"
                  points="355.041838 339.362314 360.395711 339.362314 360.395711 318.277686 355.041838 318.277686"
                />
                <polygon
                  fill="#FE9840"
                  points="364.883852 276.504548 407.194096 276.504548 407.194096 263.513124 364.883852 263.513124"
                />
                <path
                  d="M388.344231,265.987611 L388.344231,274.030386"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M402.990085,265.987611 L402.990085,274.030386"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M383.970816,265.987611 L383.970816,274.030386"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#00A7DB"
                  points="355.555257 263.545659 404.374769 263.545659 404.374769 253.156262 355.555257 253.156262"
                />
                <path
                  d="M399.289647,257.485191 L399.289647,263.545741"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="370.336991 260.514978 389.593034 260.514978 389.593034 256.18613 370.336991 256.18613"
                />
                <polygon
                  fill="#23C991"
                  points="359.21672 287.767523 401.526964 287.767523 401.526964 276.511868 359.21672 276.511868"
                />
                <polygon
                  fill="#86E0C2"
                  points="373.964281 285.06057 395.055938 285.06057 395.055938 279.707667 373.964281 279.707667"
                />
                <polygon
                  fill="#23C991"
                  points="413.384084 354.15043 397.944914 351.980312 404.628305 304.458152 420.066662 306.627456"
                />
                <path
                  d="M403.803743,309.544345 L412.535927,310.771746"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M402.471215,344.6765 L411.047989,345.88194"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M402.018332,347.898246 L410.595107,349.103686"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <polygon
                  fill="#00A7DB"
                  points="388.145536 354.104961 397.777625 354.104961 397.777625 311.808815 388.145536 311.808815"
                />
                <path
                  d="M395.402556,350.309045 L390.520605,350.309045"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="390.520605 343.429252 395.402556 343.429252 395.402556 322.344623 390.520605 322.344623"
                />
                <polygon
                  fill="#F58525"
                  points="466.759596 272.658039 496.605405 272.658039 496.605405 269.489895 466.759596 269.489895"
                />
                <polygon
                  fill="#FE9840"
                  points="483.930802 243.145252 479.434525 243.145252 471.269461 269.555128 492.095052 269.555128"
                />
                <polygon
                  fill="#FFF"
                  points="472.921839 264.212312 490.443162 264.212312 488.811777 258.933427 474.554038 258.933427"
                />
                <polygon
                  fill="#FFF"
                  points="477.817297 248.375902 476.185098 253.654787 487.180066 253.654787 485.547867 248.375902"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="446.825776 361.815874 478.541372 361.815874 478.541372 330.110846 446.825776 330.110846"
                />
                <path
                  d="M447.0667,330.389024 L478.448696,361.759751"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M478.44894,330.389024 L447.066944,361.759751"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="463.098946 330.093765 494.814542 330.093765 494.814542 298.388736 463.098946 298.388736"
                />
                <path
                  d="M463.339871,298.666915 L494.721867,330.037641"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M494.722111,298.666915 L463.340115,330.037641"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="478.558459 361.815874 510.274055 361.815874 510.274055 330.110846 478.558459 330.110846"
                />
                <path
                  d="M478.799383,330.389024 L510.181379,361.759751"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M510.181623,330.389024 L478.799627,361.759751"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  fill="#23C991"
                  points="456.487971 278.459931 502.052849 278.459931 502.052849 272.766219 456.487971 272.766219"
                />
                <path
                  d="M460.963255,278.460094 L460.963255,274.901524"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M490.661792,277.392523 L490.661792,273.833953"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <path
                  d="M495.035207,277.392523 L495.035207,273.833953"
                  stroke="#86E0C2"
                  strokeWidth="2"
                />
                <polygon
                  fill="#23C991"
                  points="459.080043 329.365946 447.875965 328.244284 451.280312 294.252011 462.483576 295.372858"
                />
                <polygon
                  fill="#86E0C2"
                  points="457.571927 317.247693 452.244091 316.714924 453.941382 299.769624 459.269218 300.302393"
                />
                <polygon
                  fill="#FE9840"
                  points="465.130652 297.610325 498.490652 297.610325 498.490652 287.813886 465.130652 287.813886"
                />
                <path
                  d="M483.386546,290.498878 L483.386546,294.925333"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M495.618437,290.498878 L495.618437,294.925333"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M480.502207,290.498878 L480.502207,294.925333"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M477.617788,290.498878 L477.617788,294.925333"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#00A7DB"
                  points="463.29992 288.196992 505.610164 288.196992 505.610164 278.568112 463.29992 278.568112"
                />
                <path
                  d="M467.097508,285.822714 L467.097508,280.942389"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="473.979188 285.822714 495.071659 285.822714 495.071659 280.942389 473.979188 280.942389"
                />
                <polygon
                  fill="#FE9840"
                  points="103.13641 281.738696 141.757526 281.738696 141.757526 271.471306 103.13641 271.471306"
                />
                <path
                  d="M124.55117,273.427259 L124.55117,279.783068"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M137.919336,273.427259 L137.919336,279.783068"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <path
                  d="M120.559199,273.427259 L120.559199,279.783068"
                  stroke="#FEC391"
                  strokeWidth="2"
                />
                <polygon
                  fill="#00A7DB"
                  points="97.34072 294.019219 138.496382 294.019219 138.496382 281.80946 97.34072 281.80946"
                />
                <path
                  d="M101.033753,291.008791 L101.033753,284.820539"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="107.727885 291.008872 128.244285 291.008872 128.244285 284.820621 107.727885 284.820621"
                />
                <polygon
                  fill="#00A7DB"
                  points="376.557411 354.104961 383.486527 354.104961 383.486527 305.301716 376.557411 305.301716"
                />
                <path
                  d="M381.649042,313.299917 L378.394408,313.299917"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <path
                  d="M381.649042,309.741347 L378.394408,309.741347"
                  stroke="#75CFEC"
                  strokeWidth="2"
                />
                <polygon
                  fill="#75CFEC"
                  points="378.394652 338.819785 381.649286 338.819785 381.649286 317.735156 378.394652 317.735156"
                />
                <path
                  d="M393.910306,161.198828 L419.167895,231.457607"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M395.00842,161.198828 L374.14296,190.838666"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <path
                  d="M395.00842,52.8824647 L395.00842,162.662112"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <rect fill="#FAFAFA" x="545" y="366" width="217" height="27" />
                <path
                  d="M389.517038,160.10108 C389.517038,163.132575 391.975101,165.589818 395.00842,165.589818 C398.040925,165.589818 400.498988,163.132575 400.498988,160.10108 C400.498988,157.068772 398.040925,154.611528 395.00842,154.611528 C391.975101,154.611528 389.517038,157.068772 389.517038,160.10108"
                  fill="#FEAD64"
                />
                <polygon
                  fill="#75CFEC"
                  points="427.762977 235.630935 367.326048 185.146418 363.100719 190.199994 423.538461 240.685324"
                />
                <path
                  d="M760.906107,381.240054 C760.906107,387.525912 755.810164,392.619344 749.523838,392.619344 L561.124459,392.619344 C554.838133,392.619344 549.742189,387.525912 549.742189,381.240054 C549.742189,374.955823 554.838133,369.861577 561.124459,369.861577 L749.523838,369.861577 C755.810164,369.861577 760.906107,374.955823 760.906107,381.240054 M753.394412,361.481247 L557.253885,361.481247 C546.337842,361.481247 537.488492,370.327648 537.488492,381.240054 C537.488492,392.153273 546.337842,400.999675 557.253885,400.999675 L753.394412,400.999675 C764.310455,400.999675 773.159805,392.153273 773.159805,381.240054 C773.159805,370.327648 764.310455,361.481247 753.394412,361.481247"
                  fill="#FEAD64"
                />
                <path
                  d="M566.921613,381.240786 L743.726358,381.240786"
                  stroke="#FEAD64"
                  strokeWidth="2"
                />
                <path
                  d="M572.961237,381.240786 C572.961237,384.272281 570.503175,386.729524 567.47067,386.729524 C564.437351,386.729524 561.980102,384.272281 561.980102,381.240786 C561.980102,378.208478 564.437351,375.751234 567.47067,375.751234 C570.503175,375.751234 572.961237,378.208478 572.961237,381.240786"
                  fill="#F58525"
                />
                <path
                  d="M616.888546,381.240786 C616.888546,384.272281 614.430484,386.729524 611.397165,386.729524 C608.36466,386.729524 605.906597,384.272281 605.906597,381.240786 C605.906597,378.208478 608.36466,375.751234 611.397165,375.751234 C614.430484,375.751234 616.888546,378.208478 616.888546,381.240786"
                  fill="#F58525"
                />
                <path
                  d="M660.81496,381.240786 C660.81496,384.272281 658.356898,386.729524 655.324392,386.729524 C652.291073,386.729524 649.833011,384.272281 649.833011,381.240786 C649.833011,378.208478 652.291073,375.751234 655.324392,375.751234 C658.356898,375.751234 660.81496,378.208478 660.81496,381.240786"
                  fill="#F58525"
                />
                <path
                  d="M704.741374,381.240786 C704.741374,384.272281 702.283312,386.729524 699.250806,386.729524 C696.217487,386.729524 693.760238,384.272281 693.760238,381.240786 C693.760238,378.208478 696.217487,375.751234 699.250806,375.751234 C702.283312,375.751234 704.741374,378.208478 704.741374,381.240786"
                  fill="#F58525"
                />
                <path
                  d="M748.667788,381.240786 C748.667788,384.272281 746.209725,386.729524 743.17722,386.729524 C740.144715,386.729524 737.686652,384.272281 737.686652,381.240786 C737.686652,378.208478 740.144715,375.751234 743.17722,375.751234 C746.209725,375.751234 748.667788,378.208478 748.667788,381.240786"
                  fill="#F58525"
                />
                <polygon points="621.74739 354.79146 584.21088 354.79146 584.21088 324.969424 604.39368 306.107783 621.74739 306.107783" />
                <polygon
                  stroke="#B0E3F4"
                  strokeWidth="2"
                  points="621.74739 354.79146 584.21088 354.79146 584.21088 324.969424 604.39368 306.107783 621.74739 306.107783"
                />
                <path d="M735.222569,354.79146 L627.86602,354.79146 L627.86602,295.862355 L721.95668,295.862355 C729.282861,295.862355 735.222569,301.79927 735.222569,309.12301 L735.222569,354.79146 Z" />
                <path
                  d="M735.222569,354.79146 L627.86602,354.79146 L627.86602,295.862355 L721.95668,295.862355 C729.282861,295.862355 735.222569,301.79927 735.222569,309.12301 L735.222569,354.79146 Z"
                  stroke="#B0E3F4"
                  strokeWidth="2"
                />
                <polygon
                  fill="#B0E3F4"
                  points="592.517846 347.680828 613.061097 347.680828 613.061097 326.935381 592.517846 326.935381"
                />
                <polygon
                  fill="#75CFEC"
                  points="592.517846 347.680828 603.095407 347.680828 603.095407 326.935381 592.517846 326.935381"
                />
                <path
                  d="M679.912096,296.951155 L679.912096,352.86666"
                  stroke="#23C991"
                  strokeWidth="2"
                />
                <path
                  d="M674.421446,296.951155 L674.421446,352.86666"
                  stroke="#23C991"
                  strokeWidth="2"
                />
                <polygon
                  fill="#B0E3F4"
                  points="645.965448 343.944126 707.072018 343.944126 707.072018 305.964627 645.965448 305.964627"
                />
                <polygon
                  fill="#EAF7FC"
                  points="651.995471 337.623292 701.042808 337.623292 701.042808 311.810442 651.995471 311.810442"
                />
                <path
                  d="M658.944522,318.587749 L694.092943,318.587749"
                  stroke="#23C991"
                  strokeWidth="2"
                />
                <path
                  d="M658.944522,324.908989 L694.092943,324.908989"
                  stroke="#23C991"
                  strokeWidth="2"
                />
                <path
                  d="M658.944522,331.23023 L694.092943,331.23023"
                  stroke="#23C991"
                  strokeWidth="2"
                />
                <polygon
                  fill="#23C991"
                  points="579.249516 357.918122 740.665538 357.918122 740.665538 352.08288 579.249516 352.08288"
                />
                <path
                  d="M632.936822,293.989124 L659.050379,248.657416"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M605.972422,266.587322 L695.656307,276.467539"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M606.337999,265.489574 L634.890904,227.432803"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M570.830998,230.359859 L653.925062,244.631555"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M568.634771,227.432722 L590.963188,197.792071"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M546.67071,204.7445 L618.418306,217.918122"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M546.305214,204.7445 L563.143064,176.201922"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M528.368193,185.71644 L586.570816,194.132559"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M528.368193,186.081813 L549.758462,157.975211"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M506.771255,163.759778 L560.215602,174.006833"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M501.646182,158.637145 L510.065921,136.681379"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M491.110687,148.070267 L526.903526,149.12279"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M490.490191,147.063862 L486.101317,116.998623"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M474.39334,130.908931 L507.136587,134.485395"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M473.845097,129.889756 L469.067294,105.57598"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M457.252484,113.449651 L482.610966,115.457091"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M456.705055,112.430558 L452.049301,89.8395357"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M444.233215,100.475959 L463.942466,101.916468"
                  stroke="#C0EADB"
                  strokeWidth="2"
                />
                <path
                  d="M633.929241,295.542043 L394.081419,48.992114"
                  stroke="#55D5A9"
                  strokeWidth="2"
                />
                <path
                  d="M721.920391,295.816073 L396.071302,49.7614972"
                  stroke="#55D5A9"
                  strokeWidth="2"
                />
                <path
                  d="M400.947964,50.0317045 C401.465451,53.0192765 399.462224,55.8596254 396.47447,56.3769398 C393.485902,56.8942542 390.644606,54.8916943 390.12712,51.9049357 C389.609633,48.9173637 391.61286,46.0770148 394.601428,45.5597004 C397.589182,45.042386 400.430478,47.0449458 400.947964,50.0317045"
                  fill="#FEAD64"
                />
                <polygon
                  fill="#23C991"
                  points="428.987126 96.4278925 460.033895 96.4278925 460.033895 89.8410811 428.987126 89.8410811"
                />
                <polygon
                  fill="#23C991"
                  points="494.050517 163.942302 553.351579 163.942302 553.351579 157.355491 494.050517 157.355491"
                />
                <polygon
                  fill="#23C991"
                  points="560.672878 230.908489 643.035463 230.908489 643.035463 224.321677 560.672878 224.321677"
                />
                <polygon
                  fill="#3BBAE3"
                  points="245.233737 362.103 425.951366 362.103 425.951366 353.969126 245.233737 353.969126"
                />
                <polygon
                  fill="#3BBAE3"
                  points="245.233737 296.015272 425.951366 296.015272 425.951366 287.881398 245.233737 287.881398"
                />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullConstruction.displayName = "NullConstruction";
NullConstruction.vstuiName = "Icon";

export default NullConstruction;
